import store from './store';

export * from './store';

export default store;
